/**
 * @fileoverview GET handler for the "/integrations/direct/cdi/import-syncs/:import_sync_id/infer_catalog_fields" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiImportSyncsImportSyncIdInferCatalogFields } from "./constants";
import type { CdiInferCatalogFieldsResult } from "./types";

export const getCdiInferCatalogFields = reactQueryFetcherAdapter(
  integrationsDirectCdiImportSyncsImportSyncIdInferCatalogFields,
  (signal: AbortSignal, importSyncId: string): Promise<CdiInferCatalogFieldsResult> => {
    return fetch(
      `/integrations/direct/cdi/import-syncs/${importSyncId}/infer_catalog_fields`,
      "GET",
      {},
      { signal }
    );
  }
);
